export default __webpack_public_path__ + "static/media/Aeonik-Bold.8cd6a3c0.woff2";